exports = module.exports = require("../../../../_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cube-tab-bar{position:relative;-webkit-box-align:center;-webkit-align-items:center;align-items:center}.cube-tab-bar,.cube-tab-bar_inline .cube-tab{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.cube-tab-bar_inline .cube-tab{-webkit-align-content:center;align-content:center}.cube-tab-bar-slider{position:absolute;left:0;bottom:0;height:.053333rem;width:.533333rem;background-color:#e8864c}", ""]);

// exports
